import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  start() {
    this.element.classList.add('spin');
  }
}
